import React, { useEffect, useState } from 'react'; 
import { useDispatch, useSelector } from 'react-redux';
import { Badge, IconButton } from "@mui/material";
import { getNotificationCount, getNotificationSeen } from 'redux/actions/UserNotification';
import notification from 'assets/images/notificationIcon.svg';
import { useNavigate, useLocation } from 'react-router-dom'; 

const Notifications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();  
  const [isPolling, setIsPolling] = useState(true);

  const tableData = useSelector((state) => state?.userNotificationCount?.userNotificationCount?.data);
  const role = localStorage.getItem('role');
  const status = localStorage.getItem('status');
  const PendingStatus = status === 'Pending';
  const filterData = {
    id: ''
  };

  // useEffect(() => {
  //   const isNotificationPage = location.pathname.split('/')[1] === 'notification'; 
  //   if (!isNotificationPage && isPolling) {
  //     dispatch(getNotificationCount(filterData));
  //     const intervalId = setInterval(() => {
  //       dispatch(getNotificationCount(filterData));
  //        console.log('Calling getNotificationCount in interval...');
  //     }, 2 * 60 * 1000);
  //     return () => {
  //       clearInterval(intervalId);
  //       setIsPolling(false);
  //     };
  //   }
  // }, [dispatch, isPolling, location.pathname]);

  useEffect(() => {
   // console.log('Starting polling for notifications');
    dispatch(getNotificationCount(filterData)); 

    const intervalId = setInterval(() => {
     // console.log('Polling notifications...');
      dispatch(getNotificationCount(filterData));
    }, 2 * 60 * 1000); // 2 minutes interval

    return () => {
      console.log('Stopping polling for notifications');
      clearInterval(intervalId);
      setIsPolling(false);
    };
  }, [dispatch, isPolling]);

  const onNotification = () => {
    dispatch(getNotificationSeen());
    navigate('/notification'); 
  };

  return (
    <IconButton
      size="large"
      aria-label="show notifications"
      color="inherit"
      className="filterBtn"
      onClick={onNotification}
      disabled={PendingStatus ? true : role === 'subVendorCompany' ? true : false}
    >
      <Badge 
        badgeContent={tableData?.notificationsCount} 
        color="error"
      >
        <img 
          src={notification} 
          alt="notification icon" 
        />
      </Badge>
    </IconButton>
  );
};

export default Notifications;
